import {
  Alert,
  AlertDescription,
  AlertTitle,
  Box,
  Card,
  CardBody,
  Center,
  Heading,
  HStack,
  Icon,
  Progress,
  Stack,
  Text,
  VStack
} from '@chakra-ui/react'
import { faClock, faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Settings } from '../icons'

export const AppOffline = () => {
  const handleRetry = () => {
    window.location.reload()
  }

  return (
    <Center minHeight="100vh" bg="gray.50" p={4}>
      <Box maxW="lg" w="full">
        <Card p={8} size="lg">
          <CardBody>
            <VStack spacing={6} textAlign="center">
              <Box>
                <Settings 
                  boxSize={16} 
                />
              </Box>
              
              <Heading 
                as="h1" 
                size="lg" 
                fontWeight="semibold"
              >
                Aplikace se aktualizuje
              </Heading>
                
              <VStack spacing={2}>
                <Text 
                  color="gray.600" 
                  fontSize="md"
                  maxW="sm"
                >
                  Provádíme aktualizaci aplikace pro zlepšení vašeho uživatelského zážitku.
                </Text>
                <Text 
                  color="gray.600" 
                  fontSize="md"
                  maxW="sm"
                >
                  Děkujeme za trpělivost.
                </Text>
              </VStack>

              <Stack w="full">
                <Progress 
                  size="sm" 
                  isIndeterminate 
                  colorScheme="blue" 
                  borderRadius="full"
                  bg="blue.200"
                />
                <Text 
                  color="blue.600" 
                  fontSize="md"
                  textAlign="center"
                >
                  Probíhá aktualizace...
                </Text>
              </Stack>

              <Alert as={Stack} status='success' alignItems="start">
                <HStack justifyContent="space-between" w="full">
                  <AlertTitle>
                    Co se děje?
                  </AlertTitle>
                  <Icon as={FontAwesomeIcon} icon={faInfoCircle} size='lg' />
                </HStack>
                <AlertDescription as={Stack} alignItems="start">
                  <Text color="green.800" textAlign="left">
                    Instalujeme nové funkce
                  </Text>
                  <Text color="green.800" textAlign="left">
                    Opravujeme chyby a vylepšujeme výkon
                  </Text>
                  <Text color="green.800" textAlign="left">
                    Aktualizujeme bezpečnostní prvky
                  </Text>
                </AlertDescription>
              </Alert>

              <Alert as={Stack} status='warning' alignItems="start">
                <HStack justifyContent="space-between" w="full">
                  <AlertTitle>
                    Očekávaná doba
                  </AlertTitle>
                  <Icon as={FontAwesomeIcon} icon={faClock} size='lg' />
                </HStack>
                <AlertDescription as={Stack} alignItems="start">
                  <Text color="orange.800" textAlign="left">
                    Několik desítek minut
                  </Text>
                </AlertDescription>
              </Alert>
            </VStack>
          </CardBody>
        </Card>
        <Text color="gray.400" textAlign="center" my={4}>
          Pokud si myslíte, že se jedná o chybu, kontaktujte prosím podporu.
        </Text>
      </Box>
    </Center>
  )
}